import styled, { css } from "styled-components";

export const TooltipTrigger = styled.div`
  display: inline-flex;
  cursor: pointer;
`;

export const TooltipContent = styled.div`
  position: absolute;
  z-index: 103;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  color: white;
  background-color: #1e1e1e;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
  pointer-events: none;
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;

  @media (max-width: 500px) {
    font-size: 12px;
  }

  ${({ position, coords }) => {
    if (!coords.width) return "";

    const baseStyles = css`
      top: ${coords.top}px;
      left: ${coords.left}px;
    `;

    switch (position) {
      case "top":
        return css`
          ${baseStyles};
          transform: translate(-50%, calc(-100% - 8px));
          transform-origin: bottom center;
        `;
      case "bottom":
        return css`
          ${baseStyles};
          transform: translate(-50%, calc(100% + 8px));
          transform-origin: top center;
        `;
      case "left":
        return css`
          ${baseStyles};
          transform: translate(calc(-100% - 8px), -50%);
          transform-origin: center right;
        `;
      case "right":
        return css`
          ${baseStyles};
          transform: translate(calc(100% + 8px), -50%);
          transform-origin: center left;
        `;
      default:
        return baseStyles;
    }
  }}
`;
